import App from 'wvus-sponsorship-app/src/App';
import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { store } from "wvus-sponsorship-engine";
import styles from "wvus-sponsorship-app/dist/sponsorship-rcds.min.css";

ReactDOM.render(
  <Provider store={store}>
      <App />
  </Provider>,
  document.getElementById("sponsorship-wrapper")
);